import {
  REQUEST_NOTICE_LIST,
  REQUEST_NOTICE,
} from './mutation-types'

import axiosInst from '@/utility/axiosInst';

export default {
  requestCreateNotice({}, payload) {
    return axiosInst.springAxiosInst.post("/admin/notice/create-notice", payload)
      .then((res) => {
        return res.data
      })
  },

  requestNoticeList({commit}, payload) {
    const {currentPage, searchType, searchWord} = payload
    return axiosInst.springAxiosInst.get("/admin/notice/notice-list", {
      params: {
        page: currentPage,
        searchType: searchType,
        searchWord : searchWord
      }
    }).then((res) => {
      commit(REQUEST_NOTICE_LIST, res.data)
    })
  },

  requestNotice({commit}, noticeSeq) {
    return axiosInst.springAxiosInst.get(`/admin/notice/notice/${noticeSeq}`)
    .then((res) => {
      commit(REQUEST_NOTICE, res.data)
    })
  },

  requestNoticeEdit({}, payload) {
    return axiosInst.springAxiosInst.post(`/admin/notice/notice-edit/${payload.get("noticeSeq")}`, payload)
    .then((res) => {
      return res.data
    })
  },

  requestDeleteNotices({}, payload) {
    return axiosInst.springAxiosInst.post('/admin/notice/delete-notices', payload)
    .then((res) => {
      return res.data
    })
  },
}